import React from "react";
import ProductSection from "./SectionNewContext";

const Products = (props) => {
  return (
    <div style={{ margin: "13rem 0 0" }}> {/* 20.5rem 0 0 for tinymce editor */}
      <ProductSection module={props.module} />
    </div>
  );
};

export default Products;
